import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Loading from '../images/loading.png'
import StripeCheckout from './stripe_checkout'
import ReactStars from "react-rating-stars-component";
import StarRatings from 'react-star-ratings';
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {Triangle} from 'react-loader-spinner';

  class Trainer extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        user_details: {},
        trainer: {},
        fitness_plans_catalogue: [],
        reviews_and_ratings: [],
        promo_videos: [],
        date: '',
        start_time: '',
        end_time: '',
        review: '',
        rating: 0,
        loading: false,
        program_price: Number
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.RatingChanged = (new_rating) => {
        this.setState({rating: new_rating})
      }

      this.RatingChanged2 = (new_rating, name) => {
        this.setState({rating: new_rating})
      }

        this.ProgramPurchaseSuccessful = (amount) => {
            this.setState({loading: true})
            const { cookies } = this.props;

            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('trainer_id', this.props.match.params.trainer_id)
            data.append('amount', amount)

            axios.post(Backend_Url + 'programPurchaseConfirm', data)
            .then((res) => {
                let result = res.data
                alert('Program purchase successful.')
                this.setState({loading: false})
            }).catch((error) => {
                console.log(error)
                this.ProgramPurchaseSuccessful()
            })
        }

      this.CheckReviewsAndRatings = () => {
          var ratings = this.state.reviews_and_ratings

          if(ratings.length == 0){
          return<div>
            <br/>
            <h6 style={{marginTop: '50px', textAlign: 'center', marginBottom: '170px'}}>
                No reviews.
            </h6>
          </div>
          }else{
            var reviews = this.state.reviews_and_ratings
            var reviews_map = reviews.map((review, index) => {
                return<Row style={{margin: '5px', border: '1px solid #1faced', borderRadius: '20px'}}>
                    <Col>
                        <h6 style={{fontSize: '15px'}}>{review.name}</h6>
                        <br/>
                        <p style={{textAlign: 'left', color: 'grey'}}>
                            {review.review}
                        </p>
                    </Col>
                </Row>
            })
            return<div style={{height: '300px', overflowY: 'scroll'}}>
                {reviews_map}
            </div>
          }
      }

      this.DeletePlan = (plan_id) => {
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('plan_id', this.props.match.params.plan_id)

        axios.post(Backend_Url + 'deleteFitnessPlanCatalogue', data)
        .then((res) => {
            let result = res.data
            alert('Program Deleted.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            console.log(error)
            this.DeletePlan(plan_id)
        })
      }

      this.ChangePlanPrice = (plan_id) => {
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('plan_id', this.props.match.params.plan_id)

        axios.post(Backend_Url + 'changeProgramPrice', data)
        .then((res) => {
            let result = res.data
            alert('Program price updated.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            console.log(error)
            this.ChangePlanPrice(plan_id)
        })
      }

      this.DeleteVideo = (plan_id) => {
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('video_id', this.props.match.params.plan_id)

        axios.post(Backend_Url + 'deleteVideo', data)
        .then((res) => {
            let result = res.data
            alert('Video Deleted.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            console.log(error)
            this.DeleteVideo(plan_id)
        })
      }
      
      this.CheckPlans = () => {
        var plans = this.state.fitness_plans_catalogue
        var trainer = this.state.trainer
        var user = this.state.user_details
        
        var user_id = ''
        var trainer_id = ''

        if (Object.keys(trainer).length !== 0){
            trainer_id = trainer._id.$oid
        }

        if (Object.keys(user).length !== 0){
            user_id = user._id.$oid
        }

        if(plans.length == 0){
            return<div>
            <br/>
            <h6 style={{marginTop: '50px', textAlign: 'center', marginBottom: '170px'}}>
                No plans yet.
            </h6>
            </div>
        }else{
            var fitness_plans_catalogue = this.state.fitness_plans_catalogue
            var fitness_plans_catalogue_map = fitness_plans_catalogue.map((item, index) => {
                return<Col sm='4' style={{width: '250px', minHeight: '300px', backgroundColor: '#FFFFFF', borderRadius: '20px'}}>
                    <a href={'/fitness-plan/' + item._id.$oid} style={{color: 'inherit'}}>
                        <img src={Backend_Url + 'media/' + item.image} style={{marginTop: '10px', width: '100%', borderTopLeftRadius: '20px', borderTopRightRadius: '20px'}}/>
                        <h5 style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                            {item.name}
                        </h5>
                        <h5 style={{marginTop: '10px', fontSize: '16px', height: '18px', lineHeight: '18px', color: '#333', fontWeight: '700'}}>
                            €{item.price}
                        </h5>
                        <br/>
                        Pay for plan
                        <br/>
                        <StripeCheckout price={item.price} origin='program' ProgramPurchaseSuccessful={this.ProgramPurchaseSuccessful}/>
                        <br/><br/>
                        {
                            user_id == trainer_id
                            ?<div style={{textAlign: 'left'}}>
                                <Button onClick={() => this.DeletePlan(item._id.$oid)} style={{color: '#ffffff', fontWeight: 'bold', border: '3px solid red', borderRadius: '20px', backgroundColor: 'red'}}>
                                    Delete Program
                                </Button>
                                <br/><br/>
                                Change Program Price
                                <br/>
                                <Input name='price' type='number' value={this.state.program_price} style={{border: 'none', borderBottom: '1px solid silver', width: '100%'}}
                                    placeholder='New price' onChange={this.HandleChange}/>
                                <br/><br/>
                                <Button onClick={() => this.ChangePlanPrice(item._id.$oid)} style={{color: '#ffffff', fontWeight: 'bold', border: '3px solid #1faced', borderRadius: '20px', backgroundColor: '#1faced'}}>
                                    Save Price
                                </Button>
                                <br/><br/>
                            </div>
                            :<div>

                            </div>
                        }
                    </a>
                </Col>
            })
            return<Row>
                {fitness_plans_catalogue_map}
            </Row>
        }
        }
 
        this.RenderPromoVideos = () => {
            var promo_videos = this.state.promo_videos
            var trainer = this.state.trainer
            var user = this.state.user_details

            var user_id = ''
            var trainer_id = ''
    
            if (Object.keys(trainer).length !== 0){
                trainer_id = trainer._id.$oid
            }
    
            if (Object.keys(user).length !== 0){
                user_id = user._id.$oid
            }

            if(promo_videos.length == 0){
                return<div>
                    This trainer hasn't uploaded any promotional videos yet.
                    <br/><br/><br/>
                </div>
            }else{
                var videos_map = promo_videos.map((video, index) => {
                    return<Col sm='3' style={{margin: '5px'}}>
                        <video controls style={{width: '100%', height: '312px', margin: '5px'}}>
                            <source src={Backend_Url + 'media/' + video.video} type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>
                        <p style={{textAlign: 'left', fontWeight: 'bold', margin: '5px'}}>
                            {video.name}
                        </p>
                        <br/><br/>
                        {
                            user_id == trainer_id
                            ?<div style={{textAlign: 'left'}}>
                                <Button onClick={() => this.DeleteVideo(video._id.$oid)} style={{color: '#ffffff', fontWeight: 'bold', border: '3px solid red', borderRadius: '20px', backgroundColor: 'red'}}>
                                    Delete Video
                                </Button>
                                <br/><br/>
                            </div>
                            :<div>

                            </div>
                        }
                    </Col>
                })

                return<Row style={{marginRight: '0px'}}>
                    {videos_map}
                </Row>
            }
        }

        this.BookSession = (amount) => {
            this.setState({loading: true})
            const { cookies } = this.props;
    
            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('trainer_id', this.props.match.params.trainer_id)
            data.append('start', this.state.date + ' ' + this.state.start_time)
            data.append('end', this.state.date + ' ' + this.state.end_time)
            data.append('timezone', 'Africa/Harare')
            data.append('amount', amount)
    
            axios.post(Backend_Url + 'bookSession', data)
            .then((res) => {
                let result = res.data
                alert('Session booked.')
                this.setState({loading: false})
            }).catch((error) => {
                console.log(error)
                this.BookSession(amount)
            })
        }

        this.AddReview = () => {
            const { cookies } = this.props;

            if (cookies.get('token') == null){
                alert('You need to be logged in to use this feature')
            }else{
                if (
                    this.state.review == '' || 
                    this.state.rating == 0
                ){
                    alert('Fill in all the fields')
                }else{
    
                    this.setState({loading: true})
                    var data = new FormData()
                    data.append('user_access_token', cookies.get('token'))
                    data.append('trainer_id', this.props.match.params.trainer_id)
                    data.append('review', this.state.review)
                    data.append('rating', this.state.rating)
            
                    axios.post(Backend_Url + 'addTrainerReviewsAndRatings', data)
                    .then((res) => {
                        let result = res.data
                        if (result == 'Success'){
                            alert('Review added successfully')
                            window.location.reload()
                        }else if (result == 'You cannot review a trainer you have never worked with'){
                            alert('You cannot review a trainer you have never worked with')
                        }else if (result == 'You cannot review yourself'){
                            alert('You cannot review yourself')
                        }
        
                        this.setState({loading: false})
                    }).catch((error) => {
                        console.log(error)
                        alert('Something went wrong, please check your data and try again.')
                        this.setState({loading: false})
                    })
                }
            }
        }
    }

    componentDidMount() {
        const { cookies } = this.props;

        axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
        .then(res => {
            if (res.data != 'Not authorized'){
              this.setState({
              user_details: res.data
              });
            }
        })
        .catch((error) => {
            console.log(error);
        });
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('trainer_id', this.props.match.params.trainer_id)
  
        axios.post(Backend_Url + 'getTrainer', data)
        .then((res) => {
            let result = res.data
            this.setState({trainer: result})
        }).catch((error) => {
            console.log(error)
        })

        axios.post(Backend_Url + 'getTrainerFitnessPlansCatalogue', data)
        .then((res) => {
            let result = res.data
            this.setState({fitness_plans_catalogue: result})
        }).catch((error) => {
            console.log(error)
        })

        axios.post(Backend_Url + 'getTrainerReviewsAndRatings', data)
        .then((res) => {
            let result = res.data
            this.setState({reviews_and_ratings: result})
        }).catch((error) => {
            console.log(error)
        })

        axios.post(Backend_Url + 'getPromoVideos', data)
        .then((res) => {
            let result = res.data
            var is_array = Array.isArray(result)
            if(is_array == true){
                this.setState({promo_videos: result})
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    render() {
        var trainer = this.state.trainer
        var user = this.state.user_details

        var promo_videos = this.state.promo_videos
        var video_1 = ''
        var video_1_name = ''
        if(promo_videos.length != 0){
            video_1 = promo_videos[0].video
            video_1_name = promo_videos[0].name
        }

        var user_id = ''
        var trainer_id = ''

        if (Object.keys(trainer).length !== 0){
            trainer_id = trainer._id.$oid
        }

        if (Object.keys(user).length !== 0){
            user_id = user._id.$oid
        }

        if(Object.keys(trainer).length === 0 || this.state.Loading === true){
            return<div>
                <Helmet>
                <title>Trainer - ONFIT</title>
                {/* <meta name="description" content="" /> */}
                </Helmet>
                <br/>
                <Container>
                    <br/>
                    <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                        ONFIT
                    </h1>
                    <br/><br/>
                    <Triangle
                        color="#1FACED"
                        height={130}
                        width={130}
                    />
                    <h3 style={{marginTop: '50px'}}>
                    Loading...
                    </h3>
                    <h6 style={{marginTop: '50px'}}>
                        Taking too long to load? Check your internet connection and reload the page.
                    </h6>
                    <br/><br/>
                </Container>
            </div>
        }

      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>TRAINER - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Container>
                <br/>
                <Row style={{marginTop: '50px', marginRight: '0px'}}>
                    <Col sm='3' style={{textAlign: 'left'}}>
                        <br/>
                        <h4 style={{textAlign: 'left', fontWeight: '700'}}>
                            {trainer.firstname} {trainer.lastname}
                        </h4>
                        <img src={Backend_Url + 'media/' + trainer.image} style={{width: '100%', marginTop: '10px'}}/>
                        <br/><br/><br/>
                        <h5 style={{textAlign: '', fontWeight: 'bold'}}>
                            Bio:
                        </h5>
                        <p style={{textAlign: 'left', color: '#666', fontSize: '14px'}}>
                            {trainer.bio}
                        </p>
                        <h4 style={{marginTop: '70px', textAlign: 'left', fontWeight: '700'}}>
                            BOOK SESSIONS
                        </h4>
                        <h4 style={{marginTop: '15px', textAlign: 'left', fontWeight: '700'}}>
                            €{trainer.session_price} / Session
                        </h4>
                        <br/>
                        Date:
                        <Input type='date' name='date' value={this.state.date} onChange={this.HandleChange}
                            style={{}}/>
                        <br/>
                        Start Time:
                        <Input type='time' name='start_time' value={this.state.start_time} onChange={this.HandleChange}
                            style={{}}/>
                        <br/>
                        End Time:
                        <Input type='time' name='end_time' value={this.state.end_time} onChange={this.HandleChange}
                            style={{}}/>
                        <br/>
                        {/* <Button onClick={this.BookSession} style={{borderRadius: '20px', backgroundColor: 'inherit', color: '#1faced', border: '3px solid #1faced'}}>
                            <h6 style={{fontWeight: 'bold'}}>Book Session</h6>
                        </Button> */}
                        Pay to book session
                        <br/>
                        <StripeCheckout price={trainer.session_price} origin='book_session' BookSession={this.BookSession}/>
                    </Col>
                    <Col>
                        <br/>
                        <Row style={{marginRight: '0px'}}>
                            <Col>
                                <h5 style={{fontWeight: 'bold'}}>
                                    Reviews and Ratings
                                </h5>
                                <br/>
                                <this.CheckReviewsAndRatings/>
                                <br/>
                                <h6 style={{fontWeight: 'bold'}}>
                                    Leave a review and rating:
                                </h6>
                                {/* <ReactStars
                                    count={5}
                                    onChange={this.RatingChanged}
                                    size={24}
                                    activeColor="#ffd700"
                                /> */}
                                <StarRatings
                                  rating={this.state.rating}
                                  starHoverColor='purple'
                                  starRatedColor="#1faced"
                                  changeRating={this.RatingChanged2}
                                  numberOfStars={5}
                                  name='rating'
                                  starDimension="24px"
                                  />                          
                                <Input name='review' type='text' value={this.state.review} style={{border: 'none', borderBottom: '1px solid silver', width: '100%'}}
                                    onChange={this.HandleChange}/>
                                <Button onClick={this.AddReview} style={{border: 'none', backgroundColor: '#1faced', width: '40%', borderRadius: '20px', marginTop: '20px'}}>
                                    Submit
                                </Button>
                                <br/><br/>
                            </Col>
                            <Col sm='6'>
                                <video controls style={{width: '100%', height: '312px', margin: '5px'}}>
                                    <source src={Backend_Url + 'media/' + video_1} type="video/mp4"/>
                                    Your browser does not support the video tag.
                                </video>
                                <p style={{textAlign: 'left', fontWeight: 'bold', margin: '5px'}}>
                                    {video_1_name}
                                </p>
                            </Col>
                        </Row>
                        <br/><br/>
                        <h4 style={{marginTop: '15px', textAlign: 'center', fontWeight: '700'}}>
                            FITNESS PLANS CATALOGUE
                        </h4>
                        <br/>
                        <this.CheckPlans/>
                    </Col>
                </Row>
                <br/>
                <h5>Promotional Videos</h5>
                <br/>
                <this.RenderPromoVideos/>
            </Container>
            <br/><br/><br/>
        </div>
      );
    }

  };
  
  export default withCookies(Trainer);